import produce from 'immer';
import { put, takeLatest, delay } from 'redux-saga/effects';
import { creator } from 'uwork-app-core';
import axios from 'utils/axios';

/**
 * External Ations
 */

/**
 * Constants
 */
export const REQUEST = '@app/orders/getcompanies/REQUEST';
export const SUCCESS = '@app/orders/getcompanies/SUCCESS';
export const FAILURE = '@app/orders/getcompanies/FAILURE';
export const CLEAR = '@app/orders/getcompanies/CLEAR';

/**
 * Initial state
 */
const initState = {
    data: null,
    loading: false
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.loading = true;
                draft.errorStatus = '';
                break;
            case SUCCESS:
                draft.data = payload.data;
                draft.loading = false;
                break;
            case FAILURE:
                draft.errorStatus = payload;
                draft.loading = false;
                break;
            case CLEAR:
                draft.data = null;
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *request({ payload }) {
        put(actions.clear());
        try {
            yield delay(200, true);
            let query = '';
            if (payload.length > 0) {
                query = '&query=' + payload;
            }
            const response = yield axios.get(`/companies?no-pagination=false${query}`);
            yield put(actions.success(response.data));
        } catch (e) {
            console.error(e);
            const error =
                e.response?.data?.message || 'Error: Something went wrong please contact support!';
            yield put(creator(CLEAR));
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
